import {Injector, NgModuleRef} from "@angular/core";
import ApolloClient from "apollo-client/ApolloClient";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {environment} from "../environments/environment";

export * from './visbos.component';
export * from './visbos.module';

// Declare type definition for JS cuid libraray
declare function cuid(): string;

const cuidConst = require("cuid");
export {cuid};


let appInjectorRef: Injector;
export const appInjector = (injector?: Injector): Injector => {
  if (injector) {
    appInjectorRef = injector;
  }

  return appInjectorRef;
};

let apolloClientRef: ApolloClient;
export const apolloClient = (client?: ApolloClient): ApolloClient => {
  if (client) {
    apolloClientRef = client;
  }

  return apolloClientRef;
};

let _appRef: NgModuleRef<any>;
export const appRef = (app?: NgModuleRef<any>): NgModuleRef<any> => {
  if (app) {
    _appRef = app;
  }
  return _appRef;
};


// WEBPACK FOOTER //
// ./src/app/index.ts